import {
  addCaseTemplate,
  getAgentList,
  getCaseTemplateIdsAll,
  GetCaseTemplateList,
  getCaseTemplateList,
  getDeviceListByHostId,
  getHostList,
  getPluginDetail,
  getSampleFile,
  getTaskBaseInfo,
  getUsCaseIdsAll,
  getUsCaseList,
  GetUsCaseList,
  getUserEmailList,
  updateCaseDetail,
  filterAttackTypeList,
} from '@/api/endpoint-security/create'
import { Message } from '@/components'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取agent列表
export const useAgentList = () => {
  const { runAsync: run, data } = useRequest(
    (params?: { os?: string[]; arch?: string[] }) => getAgentList(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('获取agent列表失败'))
      },
    },
  )

  return [run, data?.data?.items || []] as const
}

// 获取主机列表
export const useHostList = () => {
  const { runAsync: run, data } = useRequest(getHostList, {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取主机列表失败'))
    },
  })

  return [run, data?.data?.items || []] as const
}

// 根据hostId获取设备列表
export const useDeviceListByHostId = () => {
  const { runAsync: run, data } = useRequest((hostId?: string) => getDeviceListByHostId(hostId), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取设备列表失败'))
    },
  })

  return [run, data?.data?.deviceList || []] as const
}

// 获取用例模板列表
export const useCaseTemplateList = () => {
  const { runAsync: run, loading } = useRequest(
    (data: GetCaseTemplateList) => getCaseTemplateList(data),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('获取用例模板列表失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取用例模板列表筛选的全量模板ids
export const useCaseTemplateIdsAll = () => {
  const { runAsync: run, data } = useRequest(
    (params?: GetCaseTemplateList) => getCaseTemplateIdsAll(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('获取用例模板列表筛选的全量模板ids失败'))
      },
    },
  )

  return [run, data?.data?.templateIds || []] as const
}

// 获取模板关联/未关联用例列表
export const useUsCaseList = () => {
  const { runAsync: run, loading } = useRequest((data: GetUsCaseList) => getUsCaseList(data), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取模板关联/未关联用例列表失败'))
    },
  })

  return [run, loading] as const
}

// 根据筛选条件获取模板关联/未关联用例ids
export const useUsCaseIdsAll = () => {
  const { runAsync: run, data } = useRequest((params: GetUsCaseList) => getUsCaseIdsAll(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('根据筛选条件获取模板关联/未关联用例ids失败'))
    },
  })

  return [run, data?.data?.resourceIds || []] as const
}

// 添加用例模板
export const useAddCaseTemplate = () => {
  const { runAsync: run, loading } = useRequest(
    (data: {
      name: string
      resourceIds: string[]
      verificationModeIds: number[]
      sceneIds: number[]
    }) => addCaseTemplate(data),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('添加用例模板失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取用例详情
export const useCaseDetail = () => {
  const { runAsync: run, data } = useRequest((id: string) => getPluginDetail({ resource_id: id }), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取用例详情失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 查询人员邮箱列表
export const useUserEmailList = () => {
  const { runAsync: run, data } = useRequest(getUserEmailList, {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('查询人员邮箱列表失败'))
    },
  })

  return [run, data?.data?.emailUsers || []] as const
}

// 获取任务基础信息（任务复制）
export const useGetTaskBaseInfo = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskBaseInfo(id), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取任务基础信息（任务复制）失败'))
    },
  })

  return [run] as const
}

// 修改用例详情-自定义参数修改
export const useUpdateCaseDetail = () => {
  const { runAsync: run, loading } = useRequest(data => updateCaseDetail(data), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('修改用例详情-自定义参数修改失败'))
    },
  })

  return [run, loading] as const
}

// 样本文件下载
export const useGetSampleFile = () => {
  const { runAsync: run, loading } = useRequest(
    (params: { resourceId: string; sha256: string }) => getSampleFile(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('样本文件下载失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取攻击类型列表
export const useAttackTypeList = () => {
  const { runAsync: run, data } = useRequest(params => filterAttackTypeList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取攻击类型列表失败'))
    },
  })
  return [run, data?.data?.attackTypeFilters || []] as const
}
